import React, { createContext, useContext, useState, useEffect } from "react";
const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {

  // Retrieve the saved locale from localStorage or default to "en"
  const savedLocale = localStorage.getItem("locale") || "pl";
  const [locale, setLocale] = useState(savedLocale);
  const [translate, setTranslate] = useState({});

  useEffect(() => {
    try {
      const translations = require(`./../public/locales/${locale || 'pl'}/default.json`);
      setTranslate(translations);
    } catch (error) {
      console.error(`Translation file not found for locale: ${locale}`, error);
    }
  }, [locale]);

  useEffect(() => {
    localStorage.setItem("locale", locale);
  }, [locale]);

  return (
    <TranslationContext.Provider value={{ locale, setLocale, translate }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);